/**
 * 配置编译环境和线上环境之间的切换
 * 
 * baseUrl: 域名地址
 * routerMode: 路由模式
 * imgBaseUrl: 图片所在域名地址
 * 
 */

let baseUrl = ''; 
let routerMode = '';
let imgBaseUrl = '';
let accessUrl = '';

if (process.env.NODE_ENV == 'development') {
	accessUrl = "http://test.700du.com.cn/"
}else if(process.env.NODE_ENV == 'production'){
	accessUrl = "https://www.700du.cn/";
}
                                          
export {
	baseUrl,
	routerMode,
	imgBaseUrl,
	accessUrl
}


// WEBPACK FOOTER //
// ./src/util/env.js